module.exports = __webpack_public_path__ + "img/春节大促_12.876013e1.png";